import React, { useState, useEffect } from "react";
import CloseBtn from "./closeBtn";
import successIndicator from "../../assets/Homepage Assets/redesign/mark.svg";

const CloneModal = ({
    onClose,
    isDarkTheme,
    isSuccessIndicator = false,
    onButtonClick,
    heading,
    subhead,
}) => {
    const [progress, setProgress] = useState(0);
    const overlayStyles = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
        zIndex: 1000, // make sure it's above other content
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 100) {
                    clearInterval(interval); // Stop updating once progress reaches 100%
                    return 100;
                }
                return prevProgress + 5; // Increment progress
            });
        }, 500); // Update progress every 500ms

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    return (
        <div style={overlayStyles}>
            <div
                className={`bg-white dark:bg-[#0D1822] dark:border-[#424E59] border shadow-xl z-50 flex flex-col w-[577px] rounded-lg`}
            >
                <CloseBtn onClose={onClose} isDarkTheme={isDarkTheme} />
                {/* Drawer Content */}
                <div className="flex-1 px-6 text-center py-10">
                    <div className="space-y-2 mb-6">
                        {isSuccessIndicator && (
                            <div className="mb-8">
                                <img
                                    src={successIndicator}
                                    className="w-[48px] mx-auto h-[48px]"
                                    alt="cloning indicator"
                                />
                            </div>
                        )}
                        <h1 className="font-medium text-[24px] leading-6 text-[#262626] dark:text-white">
                            {heading}
                        </h1>
                        <p className="font-medium text-[15px] leading-6 text-[#8c8c8c] dark:text-white">
                            {subhead}
                        </p>
                    </div>{" "}
                    {/* Progress Bar */}
                    {!isSuccessIndicator && (
                        <>
                            <div className="w-full max-w-lg">
                                <div className="h-2 bg-gray-300 rounded-full">
                                    <div
                                        className="h-2 bg-[#009BC0] rounded-full transition-all duration-300"
                                        style={{ width: `${progress}%` }}
                                    ></div>
                                </div>
                            </div>
                            <div className="flex items-center justify-between w-full max-w-lg mt-4">
                                <div className="flex items-center gap-x-2">
                                    <svg
                                        className="animate-spin h-6 w-6 text-black"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        ></circle>
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C6.268 0 0 6.268 0 12h4z"
                                        ></path>
                                    </svg>
                                    <p className="text-sm mt-2">
                                        {progress}% complete
                                    </p>
                                </div>
                                <p className="text-sm font-medium text-[#595959]">
                                    Cloning your projects...
                                </p>
                            </div>
                        </>
                    )}
                    {isSuccessIndicator && (
                        <div className="px-6 py-4">
                            <button
                                onClick={onButtonClick}
                                className="py-[10px] px-4 bg-[#E37915] text-white rounded-lg font-semibold leading-6 text-[16px]"
                            >
                                View Cloned Project
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CloneModal;
